export  const eventTypes = {
  vacaciones: {
    name: "Vacaciones",
    color: "#1993F0",
    isSelected: true
  },
  /*tiempoCompensatorio: {
    name: "Tiempo Compensatorio",
    color: "#11830D",
    isSelected: true
  },*/
  feriados: {
    name: "Feriados",
    color: "#EC3C3D",
    isSelected: false
  }
}